(function(){
    angular
        .module('app')
        .directive('stringToNumber', stringToNumber);

        stringToNumber.$inject = ['$timeout'];
        function stringToNumber($timeout){
            return {
	            require: 'ngModel',
	            link: function(scope, element, attrs, ngModel) {
					      ngModel.$parsers.push(function(value) {
					        return '' + value;
					      });
					      ngModel.$formatters.push(function(value) {
					        return parseFloat(value);
					      });
				}
        	}
        }

      angular
        .module('app').directive('onlyNumbers', function () {
    return  {
        restrict: 'A',
        link: function (scope, elm, attrs, ctrl) {
            elm.on('keydown', function (event) {
                if(event.shiftKey){event.preventDefault(); return false;}
                //console.log(event.which);
                if ([8, 13, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {
                    // backspace, enter, escape, arrows
                    return true;
                } else if (event.which >= 48 && event.which <= 57) {
                    // numbers 0 to 9
                    return true;
                } else if (event.which >= 96 && event.which <= 105) {
                    // numpad number
                    return true;
                } 
                // else if ([110, 190].indexOf(event.which) > -1) {
                //     // dot and numpad dot
                //     return true;
                // }
                else {
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
});
})();